/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsUserControllerPatchMutationRequest,
  TelegramProductsUserControllerPatchMutationResponse,
  TelegramProductsUserControllerPatchPathParams,
  TelegramProductsUserControllerPatch401,
  TelegramProductsUserControllerPatch402,
} from '../../types/TelegramProductsUserControllerPatch.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramProductsUserPatch } from '../../methods/telegramProductsUserPatch.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramProductsUserPatchMutationKey = () => [{ url: '/api/user/telegram/products/:link' }] as const;

export type TelegramProductsUserPatchMutationKey = ReturnType<typeof telegramProductsUserPatchMutationKey>;

/**
 * {@link /api/user/telegram/products/:link}
 */
export function useTelegramProductsUserPatch<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramProductsUserControllerPatchMutationResponse,
      ResponseErrorConfig<TelegramProductsUserControllerPatch401 | TelegramProductsUserControllerPatch402>,
      {
        link: TelegramProductsUserControllerPatchPathParams['link'];
        data?: TelegramProductsUserControllerPatchMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramProductsUserControllerPatchMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramProductsUserPatchMutationKey();

  return useMutation<
    TelegramProductsUserControllerPatchMutationResponse,
    ResponseErrorConfig<TelegramProductsUserControllerPatch401 | TelegramProductsUserControllerPatch402>,
    {
      link: TelegramProductsUserControllerPatchPathParams['link'];
      data?: TelegramProductsUserControllerPatchMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ link, data }) => {
        return telegramProductsUserPatch(link, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
